import useRequest from '@swf/core/hooks/useRequest';
import type { Article } from '@swf/help';

import type { FeedbackType } from './types';

interface Props {
  type: FeedbackType;
  answerKey?: string;
  locale: string;
  article?: Article;
  url: string;
}

const useSendRequest = () => {
  const request = useRequest();

  const handleSubmit = ({ type, answerKey, locale, article = {} as Article, url }: Props) =>
    request({
      service: 'help.feedbackManager.submit',
      body: {
        comment: '',
        answerKey,
        locale,
        type,
        articleRef: article.ref,
        title: article.title,
        category: article.category,
        articleId: article.id,
        url
      }
    });

  return { handleSubmit };
};
export default useSendRequest;
